import React, { useState } from 'react';
import axios from 'axios'; 
import { useNavigate } from 'react-router-dom'; // 1. Navigate import karein
import { Mail, Lock, Key, ArrowLeft, ShieldCheck } from 'lucide-react';
import "../styles/ForgetPassword.css"

const ForgetPassword = () => {
  const navigate = useNavigate(); // 2. Hook initialize karein
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetData, setResetData] = useState({ otp: '', newPassword: '' });

  const API_URL = "https://codematrix.co.in";

// ----------------API 1: Send OTP ----------------
  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

//-----------------Backend expects email as Query Param
      const response = await axios.post(`${API_URL}/no-auth/api/users/forgot-password`, null, {
        params: { email: email.trim() }
      });

      if (response.status === 200 || response.status === 201) {
        setStep(2);
        alert("OTP sent successfully!");
      }
    } catch (error) {
      alert(error.response?.data?.message || "User not found");
    } finally {
      setLoading(false);
    }
  };

//------------------ API 2: Verify & Reset + Navigate
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Aapke backend ke hisab se saare fields params mein bhej rahe hain
      const response = await axios.post(`${API_URL}/no-auth/api/users/reset-password`, null, {
        params: {
          email: email.trim(),
          otp: resetData.otp,
          newPassword: resetData.newPassword
        }
      });

      if (response.status === 200 || response.data.status === 200) {
        alert("Success! Password updated successfully.");
        navigate('/login'); // 3. Reset hone ke baad Login page par bhej dega
      }
    } catch (error) {
      alert(error.response?.data?.message || "Invalid OTP or Reset Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
   <div className="fp-auth-wrapper">
  <div className="fp-auth-circle-bg"></div>
  <div className="fp-auth-card">

    {step === 2 && (
      <button className="fp-back-btn" onClick={() => setStep(1)} type="button">
        <ArrowLeft size={20} />
      </button>
    )}

    {step === 1 ? (
      <div className="fp-auth-content fp-fade-in">
        <div className="fp-auth-icon-box">
          <ShieldCheck size={40} color="#6366f1" />
        </div>

        <h2>Forgot Password</h2>
        <p>Enter registered email to receive OTP</p>

{/*--------------- Form -------------- */}
        <form onSubmit={handleSendOTP}>
          <div className="fp-glam-input-container">
            <Mail className="fp-input-icon" size={18} />
            <input
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="fp-auth-continue-btn" disabled={loading}>
            {loading ? 'Sending...' : 'Continue'}
          </button>
        </form>

        <p className="fp-footer-text">
          Remember password?{" "}
          <span className="fp-link-text" onClick={() => navigate('/login')}>
            Login
          </span>
        </p>
      </div>
    ) : (
      <div className="fp-auth-content fp-fade-in">
        <div className="fp-auth-icon-box">
          <Key size={40} color="#6366f1" />
        </div>

        <h2>Verification</h2>
        <p>Sent OTP to <b>{email}</b></p>

        <form onSubmit={handleResetPassword}>
          <div className="fp-otp-container">
            <input
              type="text"
              placeholder="6-Digit OTP"
              maxLength="6"
              required
              className="fp-otp-main-input"
              onChange={(e) =>
                setResetData({ ...resetData, otp: e.target.value })
              }
            />
          </div>

          <div className="fp-glam-input-container">
            <Lock className="fp-input-icon" size={18} />
            <input
              type="password"
              placeholder="New Password"
              required
              onChange={(e) =>
                setResetData({ ...resetData, newPassword: e.target.value })
              }
            />
          </div>

          <button type="submit" className="fp-auth-continue-btn" disabled={loading}>
            {loading ? 'Verifying...' : 'Reset Password'}
          </button>
        </form>
      </div>
    )}
  </div>
    </div>
  );
};

export default ForgetPassword;